
const ConverteDinheiroFunction = (number) => number?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })

export default ConverteDinheiroFunction